import React from 'react';
import {
  Input,
  NationalityAutoCompleteList,
  useIsMobile,
  useT,
  VisibilityRadioGroup,
} from '@repo/common';

import { ReactComponent as ArrowBottomIcon } from '@repo/common/assets/icons/16px/icon_16px_arrow-bottom.svg';
import { ReactComponent as ArrowTopIcon } from '@repo/common/assets/icons/16px/icon_16px_arrow-top.svg';

const NationalityInputBlock = ({
  value = '',
  id,
  onChange = () => {},
  focused,
  inputRef,
  state,
  onFocus,
  onBlur,
  onSelect,
  isRequired = false,
  isMyPage,
  visibility,
  onVisibilityChange,
  disabled,
  isMyPagePersonalInfo = false,
}) => {
  const isMobile = useIsMobile();
  const t = useT();
  return (
    <div
      className={`${isMyPagePersonalInfo ? 'flex flex-col gap-[30px] w-full' : 'relative w-full'} ${isMyPage ? 'w-full' : 'tabletH:min-w-[260px]'}`}
    >
      {isMyPage && !isMyPagePersonalInfo && (
        <VisibilityRadioGroup
          value={visibility}
          onChange={onVisibilityChange}
          disabled={disabled}
        />
      )}
      <Input
        id='nationality-input'
        ref={inputRef}
        label={
          isMyPagePersonalInfo
            ? ''
            : isMyPage
              ? t('Nationality', '국적')
              : focused
                ? `${t('Nationality', '국적')} *`
                : ''
        }
        placeholder={
          isMyPage || focused
            ? t('Select your nationality', '국적을 선택해 주세요')
            : ''
        }
        value={value}
        onChange={onChange}
        onFocus={onFocus}
        onBlur={onBlur}
        hideCount
        showStatusIcon={false}
        state={state}
        className={`placeholder:opacity-0 ${
          isMyPage ? 'w-full' : 'tabletH:max-w-[380px] w-full'
        }`}
        rightIcon={
          isMyPage ? (
            focused ? (
              <ArrowTopIcon className='transition-transform duration-300 w-5 h-5' />
            ) : (
              <ArrowBottomIcon className='transition-transform duration-300 w-5 h-5' />
            )
          ) : null
        }
        onRightIconClick={onFocus}
      />

      {!value && !focused && !isMyPage && !isMyPagePersonalInfo && (
        <span className='absolute left-4 top-[25%] text-text-placeholder pointer-events-none'>
          {isRequired ? (
            <>
              {t('Nationality', '국적')}
              <span className='text-text-accent ml-0.5'>*</span>
            </>
          ) : (
            t('Nationality', '국적')
          )}
        </span>
      )}

      {focused && (
        <div
          className={`${
            isMyPagePersonalInfo
              ? '-mt-6 w-full'
              : isMobile
                ? 'relative w-full mt-1.5'
                : 'absolute top-[86px] left-0'
          } z-10`}
          onMouseDown={(e) => e.preventDefault()}
        >
          <NationalityAutoCompleteList
            searchText={value}
            $isMobile={isMobile}
            onSelect={(val) => {
              onSelect(val);
            }}
            isMyPage={isMyPage}
            isMyPagePersonalInfo={isMyPagePersonalInfo}
          />
        </div>
      )}

      {isMyPagePersonalInfo && (
        <VisibilityRadioGroup
          value={visibility}
          onChange={onVisibilityChange}
          disabled={disabled}
        />
      )}
    </div>
  );
};

export default NationalityInputBlock;
